<template functional lang="pug">
f-model.f-users(
  model='User'
  collection='Users'
  v-bind='data.attrs'
  v-on='listeners'
)
</template>

<script lang="js">
import FModel from './f-model'

export default {
  name: 'UsersField',
  mixins: [],
  components: { FModel },
  props: {},
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style lang="scss">
.f-users {

}
</style>
